import {IEnvironmentalVariables} from './variables';

export const stagingConfig: IEnvironmentalVariables = {
    mode: 'staging',
    apiUrl: 'https://staging.exchangecollective.com/api/v2',
    appUrl: 'https://beta.exchangecollective.com',
    gaTrackerID: 'UA-110454945-3',
    stripePK: 'pk_test_IJvzhY380X1G6jYnMsKrowbU'
    // rollbarToken: 'string'
};